<template>
  <router-view/>
</template>

<style lang="less">
@import "./assets/styles/base.css";
@import url("./assets/styles/font.css");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // font-family: '阿里妈妈数黑体 Bold';
  // 禁止双击选中
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
  user-select: none;       /* 禁止文本选择（包括图片） */
  -webkit-user-drag: none; /* 禁止图片被拖动（针对WebKit浏览器） */
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.hoverstyle {
  &:hover {
    color: #6ceafb;
  }
}
.cursor {
  cursor: pointer;
}
</style>
